import {Component, Input} from '@angular/core';
import {GeneralQuantities} from '../../../model/GeneralQuantities';
import {Service} from '../../../../global/util/Service';

@Component({
  selector: 'app-consolidated-cards-report',
  templateUrl: './consolidated-cards-report.component.html',
  styleUrls: ['./consolidated-cards-report.component.css']
})
export class ConsolidatedCardsReportComponent {

  @Input() generalQuantity: GeneralQuantities;

  constructor() { }

  public getImageBy(generalQuantity: GeneralQuantities): string {
    switch (generalQuantity.id) {
      case Service.ELECTRONIC :
        return 'fa-signature';
      case Service.DIGITAL :
        return 'fa-file-signature';
      case Service.CLOUD :
        return 'fa-shekel-sign';
      case Service.REMOTE :
        return 'fa-file-contract';
      case Service.REMOTE_WITH_TIMESTAMP :
        return 'fa-signature';
      case Service.REMOTE_WITH_LTV :
        return 'fa-certificate';
      case Service.REVIEW :
        return 'fa-file-contract';
      case Service.TIMESTAMP :
        return 'fa-stamp';
      case Service.SEND_ELECTRONIC_NOTIFICATION :
        return 'fa-inbox';
      case Service.SEND_EMAIL :
        return 'fa-envelope';
      case Service.NOTCER :
        return 'fa-mail-bulk';
    }
  }
}
